import { useState, useEffect } from 'react';
import { useSelector } from 'src/redux/store';
import { callApi } from 'src/utils/apiCall';
import useFeaturePermission from './useFeaturePermission';

/**
 * Returns the count of overdue + due-today tasks for the current user.
 * Used by the sidebar nav to show a badge on the "Tasks" item.
 * Only fetches when tasks-v2 feature is enabled.
 */
export default function useTaskBadgeCount() {
    const [count, setCount] = useState(0);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { canView } = useFeaturePermission('tasks-v2');

    useEffect(() => {
        if (!practiceId || !canView) {
            setCount(0);
            return;
        }

        let cancelled = false;

        const fetchCount = async () => {
            try {
                const response = await callApi(`/api/v1/practices/${practiceId}/tasks/my-summary/`);
                if (!cancelled && response.status === 200) {
                    const { overdue = 0, due_today: dueToday = 0 } = response.data;
                    setCount(overdue + dueToday);
                }
            } catch {
                // Silently fail — badge is non-critical
            }
        };

        fetchCount();

        // Refresh every 5 minutes
        const interval = setInterval(fetchCount, 5 * 60 * 1000);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [practiceId, canView]);

    return count;
}
